import type { NitroFetchRequest, NitroFetchOptions } from 'nitropack';

/**
 * Используем для запросов после рендера компонента (по событию, например по клике на кнопке)
 * @param url адрес
 * @param options доп. параметры
 * @returns Promise<T>
 */
export function useAPI<T>(
  url: NitroFetchRequest,
  options: NitroFetchOptions<NitroFetchRequest, 'options' | 'get' | 'head' | 'patch' | 'post' | 'put' | 'delete' | 'connect' | 'trace'> | undefined = {},
): Promise<T> {
  return useNuxtApp().$api(url, options);
};
